import * as actionTypes from '../../constants/actionTypes';
import * as color from '../../constants'

let INITIAL_STATE = {
   loading: false,
   companyInfo: [],
   tagsList: [],
   tagCategories: [],
   config: {},
   selectedItems:{},
   boothConfiguration:{},
   boothConfigurationLoading: false,
   queryParams: {
      appdir: window.location.hostname.substr(0, window.location.hostname.indexOf('.')),
      urlid: window.location.href.split('/')[5],
   },
   exhibitors: {},
   exhibitorsInfo: {},
   boothsRequestLoader: false,
   customThemeStyle: {
      [color.PRIMARY_COLOR]: color.DEFAULT_PRIMARY_COLOR,
      [color.PRIMARY_DARK_COLOR]: color.DEFAULT_PRIMARY_DARK_COLOR,
      [color.PRIMARY_LIGHT_COLOR]: color.DEFAULT_PRIMARY_LIGHT_COLOR
   }, 
   isEmbed: false,
   isDirectoryEmbed: false,
}

function exhibFloorReducer(state = INITIAL_STATE, action) {
   const { payload, type } = action;
   switch (type) {
      case actionTypes.FETCH_EXHIBFLOOR_INFO_REQUEST: {
         return { ...state, loading: true }
      }
      case actionTypes.FETCH_EXHIBFLOOR_INFO_SUCCESS: {
         return { ...state, loading: false, config: payload }
      }
      case actionTypes.FETCH_EXHIBFLOOR_INFO_FAILURE: {
         return { ...state, loading: false }
      }

      case actionTypes.FETCH_COMPANY_INFO_REQUEST: {
         return { ...state, loading: true }
      }
      case actionTypes.FETCH_COMPANY_INFO_SUCCESS: {
         return { ...state, loading: false, companyInfo: payload }
      }
      case actionTypes.FETCH_COMPANY_INFO_FAILURE: {
         return { ...state, loading: false }
      }

      case actionTypes.FETCH_TAGS_REQUEST: {
         return { ...state, loading: true }
      }
      case actionTypes.FETCH_TAGS_SUCCESS: {
         const { data: { tags, tags_categories } } = payload;
         return { ...state, loading: false, tagsList: tags, tagCategories: tags_categories }
      }
      case actionTypes.FETCH_TAGS_FAILURE: {
         return { ...state, loading: false }
      }
      case actionTypes.SET_FILTER_SELECTED_ITEMS: {
         return { ...state, selectedItems: payload }
      }

      case actionTypes.FETCH_BOOTH_CONFIGURATION_REQUEST: {
         return { ...state, boothConfigurationLoading: true }
      }
      case actionTypes.FETCH_BOOTH_CONFIGURATION_SUCCESS: {
         return { ...state, boothConfigurationLoading: false, boothConfiguration: payload }
      }
      case actionTypes.FETCH_BOOTH_CONFIGURATION_FAILURE: {
         return { ...state, boothConfigurationLoading: false }
      }
      case actionTypes.UPDATE_EXHIBITOR_HASH_MAP: {
         return { ...state, exhibitors: payload.exhibitors, exhibitorsInfo: payload.exhibitorsInfo }
      }
      case actionTypes.HANDLE_BOOTH_LIST_LOADER: {
         return { ...state, boothsRequestLoader: payload }
      }

      case actionTypes.UPDATE_CUSTOM_THEME_STYLE: {
         return { ...state, customThemeStyle: payload }
      }
      case actionTypes.UPDATE_IS_EMBED: {
         return { ...state, isEmbed: payload }
      }
      case actionTypes.UPDATE_IS_DIRECTORY_EMBED: {
         return { ...state, isDirectoryEmbed: payload }
      }
      default:
         return state
   }
}

export default exhibFloorReducer